import React, { VoidFunctionComponent } from "react";
import { ProductFeature } from "@/models/scope/productSheet/ProductFeature";
import { FeatureBody } from "@/components/responsive/product/layer/features/FeatureBody";

export const FeatureBlock: VoidFunctionComponent<{ group: string, features: ProductFeature[] }> = ({
    group,
    features
}) => {
    if (group === 'Pictos') {
        return (
            <div className='pictos'>
                {features.map((feature, index) => {
                    const { value } = feature;
                    return <img src={value} key={index} alt={value} />;
                })}
            </div>
        );
    } else {
        return (
            <div className='feature-block'>
                <div className='feature-block-title'>{group}</div>
                {features.map((feature, index) => (
                    <FeatureBody feature={feature} key={feature.label + '_' + index.toString()} />
                ))}
            </div>
        );
    }
};